export const MOBILE_SCREEN = 'md';
export const MOBILE_SMALL_SCREEN = 'sm';
